export default __webpack_public_path__ + "static/media/etf-hero-l.2ba7bbf6.jpg";